export function fmtDate(d) {
  return d
    ? new Date(d).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : "";
}

export function fmtPrice(p) {
  return `TZS ${Number(p).toLocaleString()}`;
}
